// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"blog-post-module--blog-post--3ZL9A","readingTime":"blog-post-module--reading-time--1VBEd"};